var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "aside-menu"
  }, [_c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": "<i class='icon-list'></i>"
    }
  }, [_c('Callout', {
    staticClass: "m-0 py-2 text-muted text-center bg-light text-uppercase"
  }, [_c('small', [_c('b', [_vm._v("Today")])])]), _vm._v(" "), _c('hr', {
    staticClass: "transparent mx-3 my-0"
  }), _vm._v(" "), _c('Callout', {
    staticClass: "m-0 py-3",
    attrs: {
      "variant": "warning"
    }
  }, [_c('div', {
    staticClass: "avatar float-right"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("Meeting with "), _c('strong', [_vm._v("Lucas")])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted mr-3"
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v("  1 - 3pm")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "icon-location-pin"
  }), _vm._v("  Palo Alto, CA ")])]), _vm._v(" "), _c('hr', {
    staticClass: "mx-3 my-0"
  }), _vm._v(" "), _c('Callout', {
    staticClass: "m-0 py-3",
    attrs: {
      "variant": "info"
    }
  }, [_c('div', {
    staticClass: "avatar float-right"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/4.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("Skype with "), _c('strong', [_vm._v("Megan")])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted mr-3"
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v("  4 - 5pm")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "icon-social-skype"
  }), _vm._v("  On-line ")])]), _vm._v(" "), _c('hr', {
    staticClass: "transparent mx-3 my-0"
  }), _vm._v(" "), _c('Callout', {
    staticClass: "m-0 py-2 text-muted text-center bg-light text-uppercase"
  }, [_c('small', [_c('b', [_vm._v("Tomorrow")])])]), _vm._v(" "), _c('hr', {
    staticClass: "transparent mx-3 my-0"
  }), _vm._v(" "), _c('Callout', {
    staticClass: "m-0 py-3",
    attrs: {
      "variant": "danger"
    }
  }, [_c('div', [_vm._v("New UI Project - "), _c('strong', [_vm._v("deadline")])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted mr-3"
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v("  10 - 11pm")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "icon-home"
  }), _vm._v("  creativeLabs HQ ")]), _vm._v(" "), _c('div', {
    staticClass: "avatars-stack mt-2"
  }, [_c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/2.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/3.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/4.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/5.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/6.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })])])]), _vm._v(" "), _c('hr', {
    staticClass: "mx-3 my-0"
  }), _vm._v(" "), _c('Callout', {
    staticClass: "m-0 py-3",
    attrs: {
      "variant": "success"
    }
  }, [_c('div', [_c('strong', [_vm._v("#10 Startups.Garden")]), _vm._v(" Meetup")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted mr-3"
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v("  1 - 3pm")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "icon-location-pin"
  }), _vm._v("  Palo Alto, CA ")])]), _vm._v(" "), _c('hr', {
    staticClass: "mx-3 my-0"
  }), _vm._v(" "), _c('Callout', {
    staticClass: "m-0 py-3",
    attrs: {
      "variant": "primary"
    }
  }, [_c('div', [_c('strong', [_vm._v("Team meeting")])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted mr-3"
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v("  4 - 6pm")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "icon-home"
  }), _vm._v("  creativeLabs HQ ")]), _vm._v(" "), _c('div', {
    staticClass: "avatars-stack mt-2"
  }, [_c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/2.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/3.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/4.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/5.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/6.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/8.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })])])]), _vm._v(" "), _c('hr', {
    staticClass: "mx-3 my-0"
  })], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "<i class='icon-speech'></i>"
    }
  }, [_c('div', {
    staticClass: "p-3"
  }, [_c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "py-3 pb-5 mr-3 float-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "avatar-status badge-success"
  })])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted float-right mt-1"
  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
    staticClass: "text-truncate font-weight-bold"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "py-3 pb-5 mr-3 float-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "avatar-status badge-success"
  })])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted float-right mt-1"
  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
    staticClass: "text-truncate font-weight-bold"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "py-3 pb-5 mr-3 float-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "avatar-status badge-success"
  })])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted float-right mt-1"
  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
    staticClass: "text-truncate font-weight-bold"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "py-3 pb-5 mr-3 float-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "avatar-status badge-success"
  })])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted float-right mt-1"
  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
    staticClass: "text-truncate font-weight-bold"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "py-3 pb-5 mr-3 float-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "avatar-status badge-success"
  })])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted float-right mt-1"
  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
    staticClass: "text-truncate font-weight-bold"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "<i class='icon-settings'></i>"
    }
  }, [_c('div', {
    staticClass: "p-3"
  }, [_c('h6', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "aside-options"
  }, [_c('div', {
    staticClass: "clearfix mt-4"
  }, [_c('small', [_c('b', [_vm._v("Option 1")])]), _vm._v(" "), _c('c-switch', {
    staticClass: "float-right",
    attrs: {
      "type": "text",
      "variant": "success",
      "on": "on",
      "off": "off",
      "pill": true,
      "size": "sm",
      "checked": true
    }
  })], 1), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]), _vm._v(" "), _c('div', {
    staticClass: "aside-options"
  }, [_c('div', {
    staticClass: "clearfix mt-3"
  }, [_c('small', [_c('b', [_vm._v("Option 2")])]), _vm._v(" "), _c('c-switch', {
    staticClass: "float-right",
    attrs: {
      "type": "text",
      "variant": "success",
      "on": "on",
      "off": "off",
      "pill": true,
      "size": "sm"
    }
  })], 1), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]), _vm._v(" "), _c('div', {
    staticClass: "aside-options"
  }, [_c('div', {
    staticClass: "clearfix mt-3"
  }, [_c('small', [_c('b', [_vm._v("Option 3")])]), _vm._v(" "), _c('c-switch', {
    staticClass: "float-right",
    attrs: {
      "type": "text",
      "variant": "success",
      "on": "on",
      "off": "off",
      "pill": true,
      "size": "sm"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "aside-options"
  }, [_c('div', {
    staticClass: "clearfix mt-3"
  }, [_c('small', [_c('b', [_vm._v("Option 4")])]), _vm._v(" "), _c('c-switch', {
    staticClass: "float-right",
    attrs: {
      "type": "text",
      "variant": "success",
      "on": "on",
      "off": "off",
      "pill": true,
      "size": "sm",
      "checked": true
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("System Utilization")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase mb-1 mt-4"
  }, [_c('small', [_c('b', [_vm._v("CPU Usage")])])]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs",
    attrs: {
      "variant": "info",
      "value": 25
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("348 Processes. 1/4 Cores.")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase mb-1 mt-2"
  }, [_c('small', [_c('b', [_vm._v("Memory Usage")])])]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs",
    attrs: {
      "variant": "warning",
      "value": 70
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("11444GB/16384MB")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase mb-1 mt-2"
  }, [_c('small', [_c('b', [_vm._v("SSD 1 Usage")])])]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs",
    attrs: {
      "variant": "danger",
      "value": 95
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("243GB/256GB")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase mb-1 mt-2"
  }, [_c('small', [_c('b', [_vm._v("SSD 2 Usage")])])]), _vm._v(" "), _c('b-progress', {
    staticClass: "progress-xs",
    attrs: {
      "variant": "success",
      "value": 10
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("25GB/256GB")])], 1)])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d19b345","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Aside.vue
// module id = o2Ta
// module chunks = 1